import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { FormikProvider } from 'formik';
import { Button } from 'antd';
import { Form } from 'formik-antd';
import FormControl from '../../lib/form-control';
import { IFirstStep } from './interfaces';
import './create-report.less';
import InputSelect from '../../lib/input-select';
import { useStore } from '../../../store';
import { useActions } from '../../providers/actions-provider/actions.context';

const FirstStepBase = ({ formikForFirstStep }: IFirstStep): JSX.Element => {
  const { goBack } = useHistory();
  const { reportActions } = useActions();
  const { reportCollections } = useStore();
  const { setFieldValue, values: firstStepValues, submitForm } = formikForFirstStep;

  useEffect(() => {
    async function getReportData() {
      await reportActions.getCollectionsForReport();
    }
    getReportData();
  }, []);

  const preparedCollections = reportCollections.data.map((collection, index) => ({
    id: index + 1,
    name: collection,
  }));

  return (
    <FormikProvider value={formikForFirstStep}>
      <div>
        <Form className="formik-form">
          <FormControl inputClassName="formik-form__input" name="name" label="Name" type="text" />
          <FormControl inputClassName="formik-form__input" name="description" label="Description (optional)" type="text" />
          <FormControl inputClassName="formik-form__input" name="code" label="Code" type="text" />
          <InputSelect
            title="Collection"
            defaultValue=""
            fieldName="collection"
            onChange={(value: string | number) => {
            // eslint-disable-next-line array-callback-return
              reportCollections.data.find((el) => {
                if (el === value) {
                  setFieldValue('collection', el);
                }
              });
            }}
            data={preparedCollections}
          />
        </Form>
        <FormControl
          inputClassName="formik-form__input"
          name="aggregate"
          label="Aggregate (optional)"
          type="textarea"
        />
        <Button onClick={() => submitForm()} style={{ margin: '20px 0 0' }} htmlType="submit" type="primary" className="formik-form__submit" disabled={!(firstStepValues.name && firstStepValues.code && firstStepValues.collection)}>
          Next
        </Button>
        <Button onClick={() => goBack()} style={{ margin: '20px 0 0' }} htmlType="reset" type="default" className="formik-form__cancel">
          Cancel
        </Button>
      </div>
    </FormikProvider>
  );
};

FirstStepBase.displayName = 'FirstStepBase';
export default FirstStepBase;
